import { lazyLoad } from 'utils/loadable';

export const TransactionAdjustment = lazyLoad(
  () => import('./index'),
  (module) => module.default
);
